module.exports = __webpack_public_path__ + "static/media/camilo-jimenez-vGu08RYjO-s-unsplash (1).a8298f52.jpg";